import { ArrowRight, Mail } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { MEDIA, BRAND } from "@/data/content";
import { openLeadModal } from "@/components/LeadModal";
import { scrollToSection } from "@/components/Navbar";

const FinalCTA = () => (
  <section id="cta" data-testid="final-cta-section" className="relative py-32 sm:py-44 overflow-hidden">
    <video src={MEDIA.ctaVideo} autoPlay muted loop playsInline className="absolute inset-0 w-full h-full object-cover opacity-40" />
    <div className="absolute inset-0 bg-gradient-to-b from-black via-black/60 to-black" />
    <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 text-center">
      <Reveal>
        <p className="text-xs font-mono uppercase tracking-[0.35em] text-indigo-300 mb-6">Ready when you are</p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-display text-4xl sm:text-6xl font-extrabold tracking-tight text-white leading-[1.05]">
          Let's Make Your Brand <span className="text-gradient">Impossible to Ignore.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.2}>
        <p className="mt-6 text-base sm:text-lg text-zinc-300 max-w-2xl mx-auto">
          Create unforgettable experiences that people love, share, and remember.
        </p>
      </Reveal>
      <Reveal delay={0.3}>
        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          <button
            data-testid="cta-book-consultation-btn"
            onClick={() => openLeadModal()}
            className="btn-gradient text-white font-semibold px-8 py-4 rounded-full inline-flex items-center justify-center gap-2"
          >
            Book a Free Consultation <ArrowRight className="w-4 h-4" />
          </button>
          <button
            data-testid="cta-contact-brandify-btn"
            onClick={() => scrollToSection("#contact")}
            className="glass text-white font-semibold px-8 py-4 rounded-full inline-flex items-center justify-center gap-2 hover:border-indigo-400/50 transition-colors duration-300"
          >
            <Mail className="w-4 h-4" /> Contact {BRAND.name}
          </button>
        </div>
      </Reveal>
    </div>
  </section>
);

export default FinalCTA;
